import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import styles from './toggle-button.module.css';

type Props<T extends string> = {
	value: string;
	setValue: React.Dispatch<React.SetStateAction<T>>;
	btnLabel1: string;
	btnLabel2: string;
	btnId1: T;
	btnId2: T;
};

const ViewModeToggleButton = <T extends string>(props: Props<T>) => {
	const { value, setValue, btnId1, btnId2, btnLabel1, btnLabel2 } = props;
	return (
		<div className={styles['tb-container']}>
			<Button
				label={btnLabel1}
				icon={value === btnId1 ? 'pi pi-check' : undefined}
				onClick={() => setValue(btnId1)}
				pt={{
					root: {
						className: classNames(
							styles['tb-split'],
							styles['tb-root'],
							value === btnId1
								? styles['tb-on']
								: styles['tb-off'],
						),
					},
				}}
			/>
			<Button
				label={btnLabel2}
				onClick={() => setValue(btnId2)}
				icon={value === btnId2 ? 'pi pi-check' : undefined}
				pt={{
					root: {
						className: classNames(
							styles['tb-root'],
							value === btnId2
								? styles['tb-on']
								: styles['tb-off'],
						),
					},
				}}
			/>
		</div>
	);
};

export default ViewModeToggleButton;
